<ion-list class="ion-no-padding ">
  <ng-container *ngFor="let item of items; let i = index;">
    <ion-item detail="false" lines="none" button class="ion-text-center"  (click)="dismiss(i)" >
      <ion-label>
        <h3 [class]="item.color">
          {{ item.text }}
        </h3>
      </ion-label>
    </ion-item>
    <div class="divider-dark"></div>
  </ng-container>
</ion-list>
